import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { Activity } from '~/core/model/activity.model';
import { ActivityService } from '~/core/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

export const OrganizerSharedActivityResolver: ResolveFn<{
  activity: Activity;
}> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  activityService: ActivityService = inject(ActivityService),
  organizationService: OrganizerSharedOrganizationService = inject(
    OrganizerSharedOrganizationService
  )
): Observable<{ activity: Activity }> => {
  const activityId = route.paramMap.get('id');
  const organization = organizationService.organization;

  return activityService.getActivity(activityId).pipe(
    tap((activity) => {
      if (activity.organizationIdentifier !== organization.identifier) {
        throw new Error('Unauthorized');
      }
    }),
    map((activity) => ({
      activity,
    })),
    catchError((error) => {
      router.navigateByUrl('/404');

      return throwError(() => error);
    })
  );
};
